// src/api/materialotecaApi.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

/** URL pública de la foto guardada en `/uploads/materiales/` */
export const materialFotoPublicUrl = (fotoArchivo) => {
  if (!fotoArchivo || typeof fotoArchivo !== "string") return null;
  const base = (API_URL || "").replace(/\/$/, "");
  return `${base}/uploads/materiales/${encodeURIComponent(fotoArchivo)}`;
};

// ✅ Obtener todos los materiales
export const getAllMateriales = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");

  try {
    const response = await axios.get(`${API_URL}/api/materialoteca`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener materiales:", error);
    throw error;
  }
};

// ✅ Obtener grupos de material
export const getGrupos = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");

  try {
    const response = await axios.get(`${API_URL}/api/materialoteca/grupos`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener grupos:", error);
    throw error;
  }
};

// ✅ Obtener subgrupos de un grupo
export const getSubgrupos = async (grupoId) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");

  try {
    const response = await axios.get(
      `${API_URL}/api/materialoteca/subgrupos/${grupoId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener subgrupos:", error);
    throw error;
  }
};

// ✅ Añadir material
export const addMaterial = async (materialData) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");

  try {
    const response = await axios.post(
      `${API_URL}/api/materialoteca`,
      materialData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error al añadir material:", error);
    throw error;
  }
};

// ✅ Actualizar material
export const updateMaterial = async (id, materialData) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");

  try {
    const response = await axios.put(
      `${API_URL}/api/materialoteca/${id}`,
      materialData,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Error al actualizar material:", error);
    throw error;
  }
};

// ✅ Eliminar material
export const deleteMaterial = async (id) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");

  try {
    await axios.delete(`${API_URL}/api/materialoteca/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (error) {
    console.error("❌ Error al eliminar material:", error);
    throw error;
  }
};

// ✅ Obtener proveedores
export const getProveedores = async () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");

  try {
    const response = await axios.get(`${API_URL}/api/proveedores`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener proveedores:", error);
    throw error;
  }
};

/** Sube una imagen al material */
export const uploadMaterialFoto = async (materialId, file) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");

  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    `${API_URL}/api/materialoteca/${materialId}/foto`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

/** Sube varias imagenes al material */
export const uploadMaterialFotos = async (materialId, files) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");

  const list = Array.from(files || []).filter(Boolean);
  if (list.length === 0) return { uploaded: [] };

  const formData = new FormData();
  list.forEach((file) => formData.append("files", file));

  const response = await axios.post(
    `${API_URL}/api/materialoteca/${materialId}/fotos`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

/** Elimina la foto del material y el archivo en disco. */
export const deleteMaterialFoto = async (materialId) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");

  await axios.delete(`${API_URL}/api/materialoteca/${materialId}/foto`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

/** Elimina una foto concreta del material por id de foto */
export const deleteMaterialFotoById = async (materialId, fotoId) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");

  await axios.delete(`${API_URL}/api/materialoteca/${materialId}/fotos/${fotoId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
